<template>
  <basic-container>
    <el-form :inline="true"
             :model="form"
             label-position="right"
             :label-width="formLabelWidth">
      <el-form-item label="供应商名称/ID：">
        <el-input v-model="form.keyword"
                  placeholder="供应商名称/ID"></el-input>
      </el-form-item>
      <el-form-item label="创建日期：">
        <el-date-picker v-model="form.startEndDate"
                        type="daterange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-plus"
                   @click="onAdd()"
                   v-auth="'RESOURCE_SUPPLIER_ADD'">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search"
                   type="primary"
                   @click="onSubmit"
                   v-auth="'RESOURCE_SUPPLIER_SEARCH'">
          搜索
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-delete"
                   @click="onSubmitClear">清空</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData"
              border
              style="width: 100%"
              v-loading="loading">
      <el-table-column prop="productType"
                       label="供应商 ID"
                       width="180">
      </el-table-column>
      <el-table-column prop="name"
                       label="供应商名称"
                       width="180">
      </el-table-column>
      <el-table-column prop="bizType"
                       label="业务类型"
                       :formatter="formatBizType">
      </el-table-column>
      <el-table-column prop="status"
                       label="合作状态">
        <template slot-scope="scope">
          {{ scope.row.status === 1 ? '合作中' : '终止合作' }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime"
                       label="创建时间"> </el-table-column>
      <el-table-column prop="address"
                       label="操作">
        <template slot-scope="scope">
          <el-button @click.native.prevent="onAdd(scope.row)"
                     type="text"
                     size="small"
                     v-auth="'RESOURCE_SUPPLIER_EDIT'">
            编辑
          </el-button>
          <el-button :disabled="(scope.row.bizType === 3)"
                     @click="onAbilityVisible(scope.row)"
                     type="text"
                     size="small"
                     v-auth="'RESOURCE_SUPPLIER_FONFIG'">
            能力配置
          </el-button>
          <el-button @click="saveID(scope.row, 'remove')"
                     type="text"
                     size="small"
                     v-auth="'RESOURCE_SUPPLIER_DEL'">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="params.currentPage"
                   :page-sizes="[10, 20, 40, 50, 100]"
                   :page-size="params.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="total">
    </el-pagination>
    <!--  删除-->
    <el-dialog :title="tipsText.dialogTitle"
               :visible.sync="deleteStrategy"
               width="30%"
               :modal-append-to-body="false">
      <div class="dialog-text">
        {{ tipsText.dialogText }}
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="deleteStrategy = false">取 消</el-button>
        <el-button type="primary"
                   @click="dialogSure(id)">确 认</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog :title="addEditTitle"
               :visible.sync="dialogFormVisible"
               :modal-append-to-body="false">
      <el-form :model="formAdd"
               label-position="left">
        <el-form-item label="业务类型："
                      :label-width="formLabelWidth">
          <el-select v-model="formAdd.bizType"
                     @change="changeBizType"
                     :disabled="addEditTitle === '编辑供应商'">
            <el-option label="云桌面服务"
                       :value="1"
                       :key="1"></el-option>
            <el-option label="云镜像服务"
                       :value="2"
                       :key="2"></el-option>
            <el-option label="人脸认证服务"
                       :value="3"
                       :key="3"></el-option>
            <el-option label="会议RTC服务"
                       :value="4"
                       :key="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商："
                      :label-width="formLabelWidth">
          <el-select v-model="formAdd.productType"
                     :disabled="addEditTitle === '编辑供应商'"
                     @change="changeProductType">
            <div v-if="formAdd.bizType == 1">
              <el-option label="威尔云"
                         :value="1"
                         :key="1"></el-option>
              <el-option label="阿里云"
                         :value="2"
                         :key="2"></el-option>
              <el-option label="腾讯云"
                         :value="3"
                         :key="3"></el-option>
            </div>

            <div v-if="formAdd.bizType == 2">
              <el-option v-for="(item, index) in tacticsResult"
                         :key="index"
                         :label="item.label"
                         :value="item.value"></el-option>
            </div>
            <div v-if="formAdd.bizType == 3">
              <el-option label="腾讯"
                         :value="7"
                         :key="7"></el-option>
            </div>
            <div v-if="formAdd.bizType == 4">
              <el-option label="即构RTC+即构IM"
                         :value="0"
                         :key="0"></el-option>
              <el-option label="网易RTC+网易IM"
                         :value="1"
                         :key="1"></el-option>
              <el-option label="腾讯RTC+网易IM"
                         :value="2"
                         :key="2"></el-option>
              <el-option label="即构RTC+网易IM"
                         :value="3"
                         :key="3"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="合作状态："
                      :label-width="formLabelWidth">
          <el-radio v-model="formAdd.status"
                    :label="1"
                    :key="1">合作中</el-radio>
          <el-radio v-model="formAdd.status"
                    :label="2"
                    :key="2">终止</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="addSubmit">保存</el-button>
      </div>
    </el-dialog>
    <!-- 能力配置 -->
    <el-dialog width="80%"
               title="能力配置"
               :visible.sync="dialogAbilityVisible"
               :modal-append-to-body="false">
      <section class="top">
        <span class="top_name"> 供应商名称：{{ abilityConfig.name }} </span>
        <span> 业务类型：{{ abilityConfig.bizType }} </span>
      </section>
      <section class="content">
        <h4>厂商控制</h4>
        <div class="content_c">
          <el-form :model="formAbility"
                   label-position="top"
                   :inline="true">
            <div>
              能力选项：
              <el-radio v-model="formAbility.abilityOptions"
                        :label="1">默认支持所有厂商</el-radio>
              <el-radio v-model="formAbility.abilityOptions"
                        :label="2">默认不支持所有厂商</el-radio>
            </div>
            <div class="appoint">
              {{ formAbility.abilityOptions === 1 ? '排除厂商:' : '指定厂商:' }}
            </div>
            <section v-for="(item, index) in formAbility.rabbitDeviceInfoList"
                     :key="index">
              <el-form-item style="margin-right: 40px"
                            label="厂商"
                            :label-width="formLabelWidth"
                            :rules="[
                {
                  required: true
                }
              ]">
                <el-input style="width: 240px"
                          v-model="item.deviceName"
                          placeholder="请输入厂商 (ex: 小米、华为)">
                </el-input>
              </el-form-item>
              <el-form-item style="margin-right: 40px"
                            label="机型"
                            :label-width="formLabelWidth">
                <el-select v-model="item.model"
                           multiple
                           filterable
                           allow-create
                           default-first-option
                           placeholder="请输入机型">
                </el-select>
              </el-form-item>
              <el-form-item label="系统版本号"
                            :label-width="formLabelWidth">
                <el-select style="width: 120px; margin-right: 20px"
                           v-model="item.osType"
                           placeholder="AndroidTV">
                  <el-option label="AndroidTV"
                             :value="1"></el-option>
                  <el-option label="Windows"
                             :value="3"></el-option>
                  <el-option label="Mac"
                             :value="4"></el-option>
                  <el-option label="linux"
                             :value="5"></el-option>
                </el-select>
                <el-select style="width: 120px; margin-right: 20px"
                           v-model="item.osVersionLogic"
                           placeholder="大于">
                  <el-option label="大于"
                             value="gt"></el-option>
                  <el-option label="小于"
                             value="lt"></el-option>
                  <el-option label="等于"
                             value="eq"></el-option>
                  <el-option label="大于等于"
                             value="ge"></el-option>
                  <el-option label="小于等于"
                             value="le"></el-option>
                </el-select>
                <el-input v-model="item.osVersion"
                          placeholder="请输入版本号"></el-input>
                <span v-if="index === 0"
                      class="addFirm"
                      @click="addDeviceInfoList">增加厂商</span>
                <span v-else
                      class="deleteFirm"
                      @click="deleteDeviceInfoList(index)">
                  <i class="el-icon-delete"></i>
                </span>
              </el-form-item>
              <br />
            </section>
          </el-form>
          注：厂商与厂商之间为叠加关系，说明该供应商支持配置的厂商列表，非且和或的关系，厂商的能力控制中，满足任一条件即可（ex：能力支持
          小米-小米电视4 + 华为智慧屏 MAX ）
        </div>
      </section>
      <section class="content">
        <h4>SDK版本控制</h4>
        <div class="content_c">
          <el-form :model="form"
                   label-position="left"
                   :inline="true">
            <section v-for="(item, index) in formAbility.rabbitVersionInfoList"
                     :key="index">
              <el-form-item label="SDK 版本号："
                            :label-width="formLabelWidth"
                            :rules="[
                {
                  required: true
                }
              ]">
                <el-select style="width: 120px; margin-right: 20px"
                           v-model="item.sdkVersionLogic">
                  <el-option label="大于"
                             value="gt"></el-option>
                  <el-option label="小于"
                             value="lt"></el-option>
                  <el-option label="等于"
                             value="eq"></el-option>
                  <el-option label="大于等于"
                             value="ge"></el-option>
                  <el-option label="小于等于"
                             value="le"></el-option>
                </el-select>
                <el-input v-model="item.sdkVersion"
                          placeholder="输入版本号 ex：3.2.1"></el-input>
                <span v-if="index === 0"
                      class="addFirm"
                      @click="addVersionInfoList">增加条件</span>
                <span v-else
                      class="deleteFirm"
                      @click="deleteVersionInfoList(index)">
                  <i class="el-icon-delete"></i>
                </span>
              </el-form-item>
              <br />
            </section>
          </el-form>
          注：条件与条件之间，为且的关系，版本控制中，需满足所有条件（ex：SDK
          &lt;3.2.1 且 SDK &gt;5.4.0）
        </div>
      </section>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogAbilityVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="saveSure">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="操作确认"
               :visible.sync="dialogAbilitySave"
               width="30%"
               :before-close="handleClose"
               :modal-append-to-body="false">
      <span>
        保存后，配置即时生效，若配置错误，可能会导致线上无法使用，请认真核对！
      </span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogAbilitySave = false">取 消</el-button>
        <el-button type="primary"
                   @click="saveFormAbility">确 认</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>
<script>
import {
  getList,
  remove,
  submit,
  detail,
  submitDevice
} from '@/api/resource/supplier';
import tacticsResultList from "@/config/tacticsResultConfig"

export default {
  data () {
    return {
      tacticsResult: tacticsResultList,
      tipsText: {},
      typeDialog: '',
      id: '',
      channelList: [],
      deleteStrategy: false,
      loading: false,
      dialogFormVisible: false,
      total: 0,
      addEditTitle: '新增供应商',
      dialogAbilityVisible: false,
      dialogAbilitySave: false,
      params: {
        size: 10,
        current: 1
      },
      form: {
        keyword: '',
        startEndDate: '',
        createDateEnd: '',
        createDateBegin: ''
      },
      formAdd: {
        bizType: '',
        status: 1,
        productType: '',
        id: ''
      },
      formAbility: {
        abilityOptions: '',
        rabbitDeviceInfoList: [],
        rabbitVersionInfoList: []
      },
      formLabelWidth: '120px',
      abilityConfig: {
        name: '',
        bizType: ''
      },
      tableData: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 新增编辑弹框
    onAdd (row) {
      this.dialogFormVisible = true;
      this.addEditTitle = '新增供应商';
      this.formAdd = {
        bizType: '',
        status: 1,
        productType: ''
      };
      // 编辑
      if (row) {
        this.addEditTitle = '编辑供应商';
        this.formAdd.bizType = row.bizType;
        this.formAdd.productType = row.productType;
        this.formAdd.id = row.id;
        this.formAdd.status = row.status;
      }
    },
    // 增加厂商
    addDeviceInfoList () {
      const { rabbitDeviceInfoList = [] } = this.formAbility;
      const obj = {
        deviceName: '',
        model: '',
        osType: '',
        osVersion: '',
        osVersionLogic: ''
      };
      rabbitDeviceInfoList.push(obj);
      this.formAbility.rabbitDeviceInfoList = rabbitDeviceInfoList;
    },
    // 删除厂商
    deleteDeviceInfoList (index) {
      const { rabbitDeviceInfoList = [] } = this.formAbility;
      rabbitDeviceInfoList.splice(index, 1);
      this.formAbility.rabbitDeviceInfoList = rabbitDeviceInfoList;
    },
    // 增加sdk
    addVersionInfoList () {
      const { rabbitVersionInfoList = [] } = this.formAbility;
      const obj = {
        sdkVersionLogic: '',
        sdkVersion: ''
      };
      rabbitVersionInfoList.push(obj);
      this.formAbility.rabbitVersionInfoList = rabbitVersionInfoList;
    },
    // 删除sdk
    deleteVersionInfoList (index) {
      const { rabbitVersionInfoList = [] } = this.formAbility;
      rabbitVersionInfoList.splice(index, 1);
      this.formAbility.rabbitVersionInfoList = rabbitVersionInfoList;
    },
    //能力配置
    onAbilityVisible (row) {
      const bizTypeConfig = {
        1: '云桌面服务',
        2: '云镜像服务'
      };
      detail(row.id).then((res) => {
        const data = res.data.data || {};
        let {
          rabbitSupplier,
          rabbitDeviceInfoList = [],
          rabbitVersionInfoList = []
        } = data || {};
        this.abilityConfig.name = rabbitSupplier.name;
        this.abilityConfig.bizType = bizTypeConfig[rabbitSupplier.bizType];
        this.formAbility.abilityOptions = rabbitSupplier.abilityOptions || 1;
        this.formAbility.id = rabbitSupplier.id;
        //指定商家
        const arrDevice = [];
        if (rabbitDeviceInfoList.length === 0) {
          rabbitDeviceInfoList = [
            {
              deviceName: '',
              model: '',
              osType: '',
              osVersion: '',
              osVersionLogic: ''
            }
          ];
        }
        rabbitDeviceInfoList.forEach((element) => {
          const obj = {
            deviceName: element.deviceName,
            model: element.model && element.model.split(','),
            osType: element.osType,
            osVersion: element.osVersion,
            osVersionLogic: element.osVersionLogic
          };
          arrDevice.push(obj);
        });
        this.formAbility.rabbitDeviceInfoList = arrDevice;
        //SDK版本控制
        const arrSdk = [];
        if (rabbitVersionInfoList.length === 0) {
          rabbitVersionInfoList = [
            {
              sdkVersionLogic0: '',
              sdkVersion0: ''
            }
          ];
        }
        rabbitVersionInfoList.forEach((element) => {
          const obj = {
            sdkVersionLogic: element.sdkVersionLogic,
            sdkVersion: element.sdkVersion
          };
          arrSdk.push(obj);
        });
        this.formAbility.rabbitVersionInfoList = arrSdk;
      });
      this.dialogAbilityVisible = true;
    },
    saveSure () {
      this.dialogAbilityVisible = false;
      this.dialogAbilitySave = true;
    },
    // 保存
    saveFormAbility () {
      const {
        id,
        abilityOptions,
        rabbitDeviceInfoList = [],
        rabbitVersionInfoList = []
      } = this.formAbility || {};
      //  指定厂商
      const arrDevice = [];
      rabbitDeviceInfoList.forEach((item) => {
        if (item.deviceName) {
          const obj = {
            deviceName: item.deviceName,
            model: item.model && item.model.join(','),
            osType: item.osType,
            osVersion: item.osVersion,
            osVersionLogic: item.osVersionLogic
          };
          arrDevice.push(obj);
        }
      });

      //sdk
      const arrSdk = [];
      rabbitVersionInfoList.forEach((item) => {
        if (item.sdkVersion) {
          const obj = {
            sdkVersion: item.sdkVersion,
            sdkVersionLogic: item.sdkVersionLogic
          };
          arrSdk.push(obj);
        }
      });
      const parmas = {
        rabbitSupplier: {
          abilityOptions,
          id
        },
        rabbitDeviceInfoList: arrDevice,
        rabbitVersionInfoList: arrSdk
      };
      submitDevice(parmas).then(() => {
        this.dialogAbilitySave = false;
      });
    },
    handleSizeChange (val) {
      this.params.size = val;
      this.getDataList();
      console.log({ ...this.form });
    },
    handleCurrentChange (val) {
      this.params.current = val;
      this.getDataList();
    },
    onSubmit () {
      const { startEndDate, ...data } = this.form;
      if (startEndDate) {
        const createDateBegin = new Date(startEndDate[0])
          .toLocaleString()
          .replace(/\//g, '-');
        const createDateEnd = new Date(startEndDate[1])
          .toLocaleString()
          .replace(/\//g, '-');
        this.form = {
          ...this.form,
          createDateBegin,
          createDateEnd
        };
        this.getDataList({
          ...this.params,
          ...data,
          createDateBegin,
          createDateEnd
        });
      } else {
        this.getDataList({ ...this.params, ...data });
      }
    },
    onSubmitClear () {
      this.form = {
        keyword: '',
        status: '',
        createDateEnd: '',
        createDateBegin: ''
      };
      this.getDataList();
    },
    getDataList () {
      this.loading = true;
      const { startEndDate, ...data } = this.form;
      const _data = { ...this.params, ...data };
      getList(_data)
        .then((res) => {
          const data = res.data.data;
          this.total = data.total;
          this.tableData = data.records;
          this.startEndDate = startEndDate;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveID (row, type) {
      const typeConfig = {
        remove: {
          dialogTitle: '供应商删除',
          dialogText: '该条供应商是否确认删除？'
        }
      };
      this.typeDialog = type;
      this.tipsText = typeConfig[type];
      (this.deleteStrategy = true), (this.id = row.id);
    },
    removeData (id) {
      remove(id)
        .then(() => {
          this.getDataList();
        })
        .finally(() => {
          this.deleteStrategy = false;
        });
    },
    dialogSure (id) {
      if (this.typeDialog === 'remove') {
        this.removeData(id);
        return;
      }
    },
    // 新增或修改提交
    addSubmit () {
      submit({
        ...this.formAdd,
      }).then(() => {
        this.getDataList();
        this.dialogFormVisible = false;
      });
    },
    changeProductType (val) {
      let configName = {
        1: {
          1: '威尔云',
          2: '阿里云',
          3: '腾讯云'
        },
        2: {
          4: '游密',
          5: '即构',
          6: '网易',
          1: '腾讯',
          7: '乐播P2P'
        },
        3: {
          7: '腾讯'
        },
        4: {
          0: '即构RTC+即构IM',
          1: '网易RTC+网易IM',
          2: '腾讯RTC+网易IM',
          3: '即构RTC+网易IM'
        }
      }
      this.formAdd.name = configName[this.formAdd.bizType][val];
      console.log('changeProductType', val)
    },
    changeBizType (value) {
      this.formAdd.bizType = value;
      this.formAdd.productType = '';
      this.formAdd.name = '';
    },
    formatBizType ({ bizType }) {
      const type = { 1: '云桌面服务', 2: '云镜像服务', 3: '人脸识别服务', 4: '会议RTC服务' }
      return type[bizType]
    }
  },
  mounted () {
    this.getDataList();
  }
};
</script>
<style  lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 20px;
}

.el-input {
  width: auto;
}

.dialog-text {
  text-align: center !important;
}

.el-dialog__footer,
.dialog-footer {
  text-align: center;
}

.top {
  color: rgba(16, 16, 16, 100);
  font-size: 14px;
  text-align: left;
  font-family: SourceHanSansSC-regular;

  .top_name {
    margin-right: 80px;
  }
}

.content {
  font-family: SourceHanSansSC-regular;

  h4 {
    color: rgba(16, 16, 16, 100);
    font-size: 18px;
    text-align: left;
    position: relative;
    padding-left: 10px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      width: 3px;
      height: 15px;
      background: #3c7ee5;
      top: 5px;
    }
  }

  .content_c {
    padding: 16px 16px;
    background-color: rgba(249, 247, 247, 100);

    .appoint {
      color: #bd3124;
      font-size: 14px;
      text-align: left;
      margin: 30px 0 0 0;
    }

    .addFirm {
      color: #3c7ee5;
      font-size: 14px;
      margin-left: 25px;
      cursor: pointer;
    }

    .deleteFirm {
      color: #db0d0d;
      font-size: 24px;
      margin-left: 40px;
    }
  }

  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
}
</style>